import { IconVariants } from '@shared/components/Icon/IconMapper.ts';
import { defaultIconMap } from '@shared/components/Icon/iconSets/defaultIconMap.ts';
import { deIconMap } from '@shared/components/Icon/iconSets/deIconMap.ts';
import { IconSetKey, resolveIconSetKey } from '@shared/components/Icon/iconSets/resolveIconSetKey.ts';
import { UserCountryCode } from '@shared/types/countryCodes.ts';
import { CountryAssetKeys } from '@shared/utils/resolveCountryAssetKey.ts';

const iconMaps: Record<IconSetKey, Record<IconVariants, string>> = {
  [CountryAssetKeys.DEFAULT]: defaultIconMap,
  [CountryAssetKeys.DE]: deIconMap,
};

export function getIconSrc(variant: IconVariants, countryCode: UserCountryCode | null): string {
  return iconMaps[resolveIconSetKey(countryCode)][variant];
}
